export const VIDEO_POPUP_SIZE = {
  small: 'small',
  large: 'large',
}